"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const order_fragment_1 = __importDefault(require("../fragments/order.fragment"));
const query = (0, client_1.gql) `
  query orders($query: OrderQueryInput, $pagination: PaginationInput) {
    orders(query: $query, pagination: $pagination) {
      _id
      userId
      printed
      user {
        email
        firstName
        lastName
        createdAt
      }
      orgId
      eventId
      seasonId
      venueIds
      eventName
      hidden
      event {
        _id
        name
        seasonId
        subtitle
        posterImageUrl {
          original
          medium
          small
        }
        isMultipleDays
        schedule {
          startsAt
          endsAt
          __typename
        }
        performances {
          schedule {
            doorsAt
            startsAt
          }
        }
        sendQRCode
        venueId
        venue {
          _id
          name
          address {
            state
            city
            timezone
          }
        }
      }
      season {
        _id
        name
        subtitle
        posterImageUrl {
          original
          medium
          small
        }
        sendQRCode
        performances {
          schedule {
            doorsAt
            startsAt
          }
        }
        schedule {
          startsAt
          endsAt
        }
        venueId
        venue {
          _id
          name
          address {
            state
            city
            timezone
          }
        }
      }
      fees {
        _id
        name
        orgId
        eventId
        type
        value
        minAppliedToPrice
        maxAppliedToPrice
        filters
        appliedTo
        appliedBy
        createdBy
        createdAt
        updatedBy
        updatedAt
        disabled
        amount
      }
      createdAt
      stripeChargeId
      state
      refundedAmount
      promotionCode
      type
      channel
      tax
      ipAddress
      address {
        lat
        lng
        zip
      }
      orderIntegrationResponse {
        success
        title
        message
        statusCode
        actionType
        createdAt
        orderType
      }
      payments {
        _id
        paymentIntentId
        amount
        transferAmount
        feeAmount
        feeIds
        createdAt
        createdBy
        promotionCode
        paymentMethodType
      }
      promoterFee {
        amount
        refund {
          refunded
          refundedAt
          refundedBy
          refundReason
          refundedAmount
          promoterFee
          salesTaxFee
        }
      }
      processingFee {
        amount
        refund {
          refunded
          refundedAt
          refundedBy
          refundReason
          refundedAmount
          selloutFee
          stripeFee
        }
      }
      ...OrderTickets
      ...OrderUpgrades
    }
  }
  ${order_fragment_1.default.fragments.tickets}
  ${order_fragment_1.default.fragments.upgrades}
`;
exports.default = query;
//# sourceMappingURL=orders.query.js.map